// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button{border:none}.content-CkNWQ{margin-top:30px}.blocks-nDn-d{display:flex;justify-content:center;gap:20px}.block-d\\+04S{display:flex;flex-direction:column;flex:1;gap:12px}.item-iDISa,.itemRow-m1-Oi{padding:16px 30px 20px;min-width:230px;background:hsla(0,0%,100%,.0666666667);display:flex;flex-direction:column;gap:8px;text-align:center;letter-spacing:1px}.itemRow-m1-Oi{flex-direction:row;align-items:center;gap:10px;padding-bottom:16px;cursor:pointer}.title-9O5ZW{color:#f8f8f8;font-weight:400;opacity:.69}.text-\\+oBiG{color:#f8f8f8;font-weight:300;line-height:1.2;white-space:pre-wrap}.textDanger-s5P-1{color:#d60000;text-transform:uppercase}.link-ci5AY{display:flex;flex-direction:column;justify-content:initial !important;align-items:initial !important;user-select:text}@media(max-width: 1280px){.blocks-nDn-d{flex-direction:column;gap:10px}.item-iDISa,.itemRow-m1-Oi{min-width:100%;box-sizing:border-box}}@media(max-width: 700px){.blocks-nDn-d{flex-direction:column;gap:2px}.block-d\\+04S{gap:2px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "content-CkNWQ",
	"blocks": "blocks-nDn-d",
	"block": "block-d+04S",
	"item": "item-iDISa",
	"itemRow": "itemRow-m1-Oi",
	"title": "title-9O5ZW",
	"text": "text-+oBiG",
	"textDanger": "textDanger-s5P-1",
	"link": "link-ci5AY"
};
export default ___CSS_LOADER_EXPORT___;
